<template>
  <b-sidebar
    :id="id"
    title="Informações visíveis"
    backdrop-variant="dark"
    backdrop
    right
    shadow
  >
    <div class="px-2 py-2">
      <div style="width: 100%" class="p-2">
        <h4 class="text-dark">Colunas customizadas</h4>
        <p>
          Selecione abaixo quais colunas deseja que estejam visíveis na listagem
          de {{ moduleLabel }}. Arraste para definir a ordem.
        </p>
      </div>
      <div
        style="width: 100%; max-height: 100%; overflow-y: scroll"
        class="mb-2"
      >
        <draggable
          v-model="localFields"
          handle=".drag-handle"
          :animation="150"
          ghost-class="drag-ghost"
        >
          <div
            v-for="field in localFields"
            :key="field.field"
            class="column-custom-item mb-0 ml-1 mr-1 p-1 rounded"
          >
            <div style="display: flex; align-items: center; gap: 10px">
              <span
                class="drag-handle"
                style="cursor: grab"
                title="Arraste para reordenar"
              >
                <DragVertical :size="20" class="text-muted" />
              </span>
              <span
                class="switch switch-icon"
                :class="{ 'switch-disabled': isFieldRequired(field) }"
              >
                <label>
                  <input
                    type="checkbox"
                    :disabled="isFieldRequired(field)"
                    @change="
                      handleToggleField($event.target.checked, field.field)
                    "
                    :checked="isFieldSelected(field.field)"
                  />
                  <span></span>
                </label>
              </span>
              <label
                class="mb-0"
                :class="{
                  'text-muted font-weight-bold': isFieldRequired(field),
                }"
              >
                {{ field.label }}
              </label>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <template #footer>
      <div class="d-flex text-light align-items-center px-3 py-2">
        <button
          style="width: 100%"
          class="btn btn-primary btn-hover-dark font-weight-bold"
          @click="handleSave"
        >
          Salvar
        </button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";
import DragVertical from "vue-material-design-icons/DragVertical.vue";

export default {
  name: "ColumnVisibilitySidebar",
  components: { draggable, DragVertical },
  props: {
    id: {
      type: String,
      required: true,
    },
    moduleLabel: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    visibleFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localFields: [],
      selectedFields: new Set(),
    };
  },
  watch: {
    visibleFields: {
      immediate: true,
      deep: true,
      handler() {
        this.syncFromProps();
      },
    },
    fields: {
      deep: true,
      handler() {
        this.syncFromProps();
      },
    },
  },
  methods: {
    isFieldRequired(field) {
      return field.required === true;
    },
    isFieldSelected(fieldKey) {
      return this.selectedFields.has(fieldKey);
    },
    syncFromProps() {
      const visibleKeys = new Set(
        (this.visibleFields || []).map((field) => field.field)
      );
      const allFields = _.cloneDeep(this.fields || []);

      // Visíveis primeiro (na ordem recebida), depois as ocultas (ordem original).
      const orderedVisible = (this.visibleFields || []).filter((field) =>
        allFields.find((f) => f.field === field.field)
      );
      const hiddenFields = allFields.filter(
        (field) => !visibleKeys.has(field.field)
      );

      this.localFields = [...orderedVisible, ...hiddenFields];
      this.selectedFields = new Set(visibleKeys);
    },
    handleToggleField(value, fieldKey) {
      if (value) {
        this.selectedFields.add(fieldKey);
      } else {
        this.selectedFields.delete(fieldKey);
      }
      // Força reatividade do Set
      this.selectedFields = new Set(this.selectedFields);
    },
    handleSave() {
      const savedFields = this.localFields.filter((field) =>
        this.selectedFields.has(field.field)
      );
      this.$emit("save", savedFields);
    },
  },
};
</script>

<style scoped>
.column-custom-item:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
.drag-ghost {
  opacity: 0.4;
  background: #c8ebfb;
}
.switch-disabled {
  opacity: 0.6;
}
</style>
